<template>
  <div
    class="flex flex-col"
    :class="containerStyleClasses ?? 'w-full'"
  >
    <div
      class="flex my-1"
      :class="[arrangeLabelAndInputVertically? 'flex-col justify-center' : 'flex-row items-center']"
    >
      <label
        :for="fieldName"
        :class="[labelStyleClasses, arrangeLabelAndInputVertically? 'my-1.5' : 'mr-2']"
      >{{ labelText }}</label>
      <div class="flex flex-row items-center justify-center w-full">
        <select
          class="w-full border focus:outline-none rounded h-10 py-0.5 px-2 text-sm md:text-base"
          :class="errors.length > 0
            ? 'border-a-error'
            : 'border-a-neutral-dim hover:border-a-neutral-lightest focus:border-a-primary bg-white'
            "
          id=""
          v-model="selectedValue"
          @blur="$event => onBlur($event)"
          :autofocus="isAutoFocused"
        >
          <option
            v-if="hasNullOption"
            class="text-center bg-white"
            :value="null"
          >
            {{ nullOptionText }}
          </option>
          <option
            :value="optionValue ? option[optionValue] : option"
            v-for="option in options"
            :key="optionValue ? option[optionValue] : option"
            class="bg-white"
          >
            {{ optionText ? option[optionText] : option }}
          </option>
        </select>
        <template v-if="showErrorIcon">
          <span v-show="errors.length > 0">
            <Icon
              name="mdi:close-circle"
              class="text-lg text-a-error mx-2"
            />
          </span>
        </template>
      </div>
    </div>
    <div class="flex flex-row">
      <span class="text-a-error text-xs md:text-sm flex flex-row items-center">
        {{ errors[0] }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
const baseSelectRef = ref(null);
const emit = defineEmits([
  "update:model-value",
]);
const props = withDefaults(defineProps<{
  modelValue: string | number | null;
  labelText?: string;
  labelStyleClasses?: string;
  arrangeLabelAndInputVertically?: boolean;
  options: any[];
  optionValue?: string;
  optionText?: string;
  hasNullOption?: boolean;
  nullOptionText?: string;
  fieldName: string;
  validationLabel?: string;
  validationRules?: string;
  tailwindClasses?: string;
  containerStyleClasses?: string;
  showErrorIcon?: boolean;
  isAutoFocused?: boolean
}>(), {
  labelText: "",
  labelStyleClasses: "",
  validationLabel: "Selection",
  validationRules: "",
  tailwindClasses: "",
  containerStyleClasses: "",
  showErrorIcon: true,
  isAutoFocused: false
});

function onBlur(event: Event) {
  handleBlur(event, true);
}

const selectedValue = ref(props.modelValue);

watch(() => props.modelValue, (newValue) => {
    selectedValue.value = newValue;
});

watch(selectedValue, (newValue) => {
  emit("update:model-value", newValue);
});

const { errors, handleBlur,resetField } = useField(() => {
  return props.fieldName
}, props.validationRules, { syncVModel: true, label: props.validationLabel });


function resetValidation() {
  resetField();
}

defineExpose({
  resetValidation
})

</script>

<style></style>
